// Granting Role  Types
export enum RoleType { available = 0, current, future, graceExp, expired };  
